import React, {Component} from 'react'

// styl
import './IndexNavigation.styl'

class IndexNavigation extends Component{
  render() {
    return (
      <div className='index-navigation'>
        {(this.props.systemList || []).map((item, index) => {
          return (
            <div
              className={`index-navigation-item flex-row-center-center pointer ${item.active ? 'active' : ''}`}
              key={item.id}
              onClick={this.props.onClickNavigation.bind(this, index)}
            >
              <span className={`icon iconfont ${item.iconClassName} index-navigation-item-icon`}></span>
              <span className="system-name fs-12 text-ellipsis">{item.title}</span>
            </div>
          )
        })}
      </div>
    );
  }
}

export default IndexNavigation
